// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    firebaseConfig: {
        //    apiKey: "AIzaSyAxhugpQ-LQW7VI8NTv6NHTQTi94pYWPpM",
        //    authDomain: "fir-test-46957.firebaseapp.com",
        //    databaseURL: "https://fir-test-46957.firebaseio.com",
        //    projectId: "fir-test-46957",
        //    storageBucket: "fir-test-46957.appspot.com",
        //    messagingSenderId: "829461719043",
        apiKey: "AIzaSyDe1-NGcxFDMb2NBIts1-MRbViV0MMZkKI",
        // authDomain: "clarehome-sso.firebaseapp.com",
        authDomain: "dealerdev.clarecontrols.com", // Test for now to see if this helps
        databaseURL: "https://clarehome-sso.firebaseio.com",
        projectId: "clarehome-sso",
        storageBucket: "clarehome-sso.appspot.com",
        messagingSenderId: "713869724902",
    },
    // ralinkUrl: "https://ralinkbeta.clarecontrols.com",
    ralinkUrl: "https://ralinktest.clarecontrols.com",
    websocketUrl: "wss://wsproxy.clarecontrols.net/ws",
    myClareHomeUrl: "https://dev.myclarehome.com",
    // myClareHomeUrl: "https://www.myclarehome.com",
    // websocketUrl: "ws://localhost:8080/ws",
    dealerWPFusionURL: "https://fusiontest.clarecontrols.com/cc?uuid=",
    // clareRSSFeedURL: "https://rss.nytimes.com/services/xml/rss/nyt/World.xml",
    clareRSSFeedURL: "https://www.clarecontrols.com/fusionpro-news/rss.xml",
    firebaseCheckEmailWebsocketUrl: "https://wsproxy.clarecontrols.net/firebase_check_email",
};
